import React from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../../../store';
import Table, {
  TableType,
  TableExtra,
  TableCell,
  TableRow,
} from '../../../../../../../components/common/table';
import { Visibility, FileProps } from '../../../../../../../types/common-types';
import './style.scss';

interface ValueProps {
  id: string;
  value: string;
  error: boolean;
}

interface Props {
  id: string;
  type?: TableType;
  value?: string;
  error?: boolean;
  head: TableCell[];
  body: TableRow[];
  required?: boolean;
  errorMsg?: string;
  helpMsg?: string;
  extra: TableExtra;
  visibility?: Visibility;
  onSubmit: (id: string, buttonData?: Record<string, unknown>) => void;
  onChange: (value: ValueProps, callback?: () => void) => void;
  previewFile: (file: FileProps) => void;
  submitOnChange?: boolean;
}

const TableBF: React.FC<Props> = ({
  id,
  value,
  type,
  visibility,
  required,
  errorMsg,
  head,
  body,
  error,
  extra,
  helpMsg,
  submitOnChange = false,
  onChange,
  onSubmit,
  previewFile,
}) => {
  const { submitingButtonId } = useSelector(
    (state: ApplicationState) => state.page
  );
  const handleOnChange = (data: ValueProps) => {
    onChange(data, () => {
      if (submitOnChange) onSubmit(id);
    });
  };
  return (
    <Table
      id={id}
      type={type}
      styleName={cn('table')}
      visibility={visibility}
      submiting={submitingButtonId === id}
      head={head}
      body={body}
      value={value}
      extra={extra}
      error={error}
      required={required}
      onChange={handleOnChange}
      onClick={onSubmit}
      onFileClick={previewFile}
      helperText={error ? errorMsg : helpMsg}
    />
  );
};
export default TableBF;
